import { WidgetType } from 'widgets/WidgetType';
import React, { PropsWithChildren, useContext } from 'react';
import omit from 'lodash/omit';
import { WidgetHost } from 'widgets/WidgetRegistry';

export interface WidgetContextType {
    widgetKey: string;
    widgetType: WidgetType;
    host: WidgetHost;
    width: number;
    height: number;
    isHovering: boolean;
}

const defaultWidgetContext = {} as WidgetContextType;

export const WidgetContext =
    React.createContext<WidgetContextType>(defaultWidgetContext);

export type WidgetContextProviderProps = PropsWithChildren<WidgetContextType>;

export function WidgetContextProvider(props: WidgetContextProviderProps) {
    const value = omit(props, 'children');
    return (
        <WidgetContext.Provider value={value}>
            {props.children}
        </WidgetContext.Provider>
    );
}

export const useWidgetContext = () => useContext(WidgetContext);
